var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"404"},[_c('van-empty',{attrs:{"description":"您已迷路！"}},[_c('van-button',{staticClass:"bottom-button",attrs:{"to":"/","round":"","type":"danger"}},[_vm._v(" 返回首页 ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }